import axios from '../../axios'

/*
 * 机构数据接口
 */

// 获取机构列表
export const getAgentList = (data) => {
    return axios({
        url: '/api/base/agent',
        method: 'get',
        data
    })
}

// 新增机构信息
export const saveAgent = (data) => {
    return axios({
        url: '/api/base/agent',
        method: 'post',
        data
    })
}

// 编辑机构信息
export const updateAgent = (data) => {
    return axios({
        url: '/api/base/agent',
        method: 'put',
        data
    })
}

// 删除机构列表
export const deleteAgent = (data) => {
    return axios({
        url: '/api/base/agent',
        method: 'delete',
        data
    })
}

// 导出机构信息
export const exportAgent = (data) => {
    return axios({
        url: '/api/base/agent/export',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/agent.js